module.exports = __webpack_public_path__ + "img/collection-engagementRingsPrincess.c9b973f.jpg";